import {
  IDefenseEventGetByIdParams,
  IDefenseEventProps,
  IDefenseEventSimpleProps,
} from './types';
import { api } from '../../DefaultService';
import { IPaginationParams } from '../../types';

export const DEFENSE_EVENTS_ENDPOINT = 'v1/events/defense';

export const getAllByLicenseAsync = async (
  pagination?: IPaginationParams,
): Promise<IDefenseEventSimpleProps[]> => {
  return await api
    .get(`${DEFENSE_EVENTS_ENDPOINT}/getAllByLicense`, {
      params: { ...pagination },
    })
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

export const getAllByLicenseCountAsync = async (): Promise<number> => {
  return await api
    .get(`${DEFENSE_EVENTS_ENDPOINT}/getAllByLicense/count`)
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

export const getByIdAsync = async ({
  id,
  type,
}: IDefenseEventGetByIdParams): Promise<IDefenseEventProps> => {
  return await api
    .get(`${DEFENSE_EVENTS_ENDPOINT}/${id}`, {
      params: { type },
    })
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};
